import { render, staticRenderFns } from "./politicsProjectCreate.vue?vue&type=template&id=f72e28a8&scoped=true"
import script from "./politicsProjectCreate.vue?vue&type=script&lang=js"
export * from "./politicsProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectCreate.vue?vue&type=style&index=0&id=f72e28a8&prod&lang=less&scoped=true"
import style1 from "./politicsProjectCreate.vue?vue&type=style&index=1&id=f72e28a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e28a8",
  null
  
)

export default component.exports